import isolate from "@cycle/isolate"

import * as R from "ramda"

import { INPUT_CHECK, STATE_KEY } from "../../../../constant"

import {
  createCheckInfo,
} from "../../../common"
import { InputCheck, ModificationType} from "../../../../interface"

import { view } from "./view"
import { Confirm, Form } from ".."

const INPUT_CHECKS: InputCheck[] = [
  createCheckInfo("lastName", /./, "姓は必須入力です。"),
  createCheckInfo("firstName", /./, "名は必須入力です。"),
  INPUT_CHECK["lastNameEng"],
  INPUT_CHECK["firstNameEng"],
  INPUT_CHECK["middleNameEng"],
  createCheckInfo(
    "lastNameYomi",
    /^[\u{3000}-\u{301C}\u{3041}-\u{3093}\u{309B}-\u{309E}\u{30fc}]+$/u,
    // /^[ァ-ヶ]*$/,
    "姓(よみ)を全角ひらがなで入力して下さい。",
  ),
  createCheckInfo(
    "firstNameYomi",
    /^[\u{3000}-\u{301C}\u{3041}-\u{3093}\u{309B}-\u{309E}\u{30fc}]+$/u,
    // /^[ァ-ヶ]*$/,
    "名(よみ)を全角ひらがなで入力して下さい。",
  ),
  createCheckInfo("jsog", /^(\d{8})*$/, "半角数字8桁で入力して下さい。", false),
  createCheckInfo(
    "jua",
    /^(\d{5,6})*$/,
    "半角数字5/6桁で入力して下さい。",
    false,
  ),
]

export default isolate(Form("base", STATE_KEY.BaseForm, view, INPUT_CHECKS))

const getReqParam = ([user, form] : [any, any]) => {
  const type = ModificationType.Basic
  const memberId = R.prop("id", user)
  return {
    type, memberId, body: form,
  }
}

export const BaseConfirm = isolate(Confirm(STATE_KEY.BaseForm, view, getReqParam))
